export default Object.freeze({
  GET_COURSE_DATA_FAIL: 'GET_COURSE_DATA_FAIL',
  GET_COURSE_DATA_SUCCESS: 'GET_COURSE_DATA_SUCCESS',
  SET_QUERY_STRING: 'SET_QUERY_STRING',
});
